import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Button, Icon } from '@innovationnorway/cl-react';
import { OneWayInServiceDto } from 'src/api/v2';

const columnHelper = createColumnHelper<OneWayInServiceDto>();

export const serviceColumns = [
  columnHelper.accessor((row) => row.name, {
    id: 'serviceName',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
  columnHelper.accessor((row) => row.businessName, {
    id: 'actor',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
  columnHelper.accessor((row) => row.contactName, {
    id: 'contactPerson',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
];

type ServiceColumnOptions = {
  onToggleInfo: (service: OneWayInServiceDto) => void;
  infoAriaLabel: string;
};

export const getServiceColumns = ({ onToggleInfo, infoAriaLabel }: ServiceColumnOptions) => [
  columnHelper.accessor((row) => row.name, {
    id: 'serviceName',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
  columnHelper.accessor((row) => row.contactName, {
    id: 'contactPerson',
    cell: (info) => {
      return <span>{info.getValue()}</span>;
    },
  }),
  columnHelper.display({
    id: 'info',
    header: () => null,
    cell: ({ row }) => {
      return (
        <div className="service-table--info-cell">
          <Button
            variant="tertiary"
            icon
            aria-label={infoAriaLabel}
            onClick={() => onToggleInfo(row.original)}
          >
            <Icon prefix="fasr" iconName="circle-info" />
          </Button>
        </div>
      );
    },
  }),
];
